<template>
    <ApproveTeamLevel />
    
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
export default {
    name: 'ApproveLevelTeamPageWrapper',
    components: {
        ApproveTeamLevel: () => import('./ApproveTeamLevel.vue'),
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [{title: "Duyệt Level Team", icon: 'fas fa-clipboard-check'}]);
    },
}
</script>